import React from 'react';

import {EntityLogo} from "../../../logos/entity-logo";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {CompetitorViewModel} from "../../../../../domain/common/competitor/models/competitor-view-model";
import classNames from 'classnames';
import styles from '../../style/slider.game-card.module.scss';
import {Ellipsis} from "../../../misc/ellipsis/ellipsis";

export class SliderWidgetCardCompetitorProps extends BaseProps {
  competitor: CompetitorViewModel;
  isSmallView: Boolean;
}

export const SliderGameCardCompetitor = ({competitor, isSmallView}: SliderWidgetCardCompetitorProps) => {
  const entityProps = {
    entity: competitor,
    width: isSmallView ? 32 : 40,
    height: isSmallView ? 32 : 40,
    style: {
      margin: 0,
      minHeight: isSmallView ? 32 : 40
    }
  }

  return (
    <div className={classNames(styles.slider_widget_card_competitor)}>
      <EntityLogo {...entityProps}/>
      <Ellipsis className={classNames(styles.slider_widget_card_competitor_name)}
                text={competitor.shortName || competitor.name}/>
    </div>
  )
};
